import React from 'react';
import styled from 'styled-components';
import BoardPagination from '../BoardPagination';
import SearchDelete16Icon from '../Icons/SearchDelete16Icon';
import TopbarSearchIcon from '../Icons/TopbarSearchIcon';
import SearchAddressNoti from './SearchAddressNoti';
import SearchAddressResult from './SearchAddressResult';
import { SearchAddress as SearchAddressType } from '@remodeling/common';
import useSearchAddress from '@/feat-components/UntactConsultRequest/hooks/useSearchAddress';
import { theme } from '@/styles';

export type SearchAddressProps = {
  handleSearchAddress: (address: SearchAddressType) => void;
};

function SearchAddress({ handleSearchAddress }: SearchAddressProps) {
  const {
    page,
    handlePage,
    placeholder,
    handleSearchInput,
    value,
    handleSearchDelete,
    handleSubmit,
    inputError,
    hasResult,
    _value,
    totalNum,
    addressList,
    SIZE,
  } = useSearchAddress();

  return (
    <SearchAddressWrap>
      <SearchAddressContent>
        <form>
          <SearchInputWrap>
            <SearchInput
              placeholder={placeholder}
              onChange={handleSearchInput}
              value={value}
            />
            <SearchButtonWrap>
              {value.length > 0 && (
                <SearchDeleteButton
                  type={'button'}
                  onClick={handleSearchDelete}
                >
                  <SearchDelete16Icon />
                </SearchDeleteButton>
              )}
              <SearchButton type={'submit'} onClick={handleSubmit}>
                <TopbarSearchIcon boxSize={'32px'} />
              </SearchButton>
            </SearchButtonWrap>
          </SearchInputWrap>
          {inputError !== '' && <InputError>{inputError}</InputError>}
        </form>
        {hasResult ? (
          <SearchAddressResult
            page={page}
            value={_value}
            totalNum={totalNum}
            addressList={addressList as SearchAddressType[]}
            handleSearchAddress={handleSearchAddress}
          />
        ) : (
          <SearchAddressNoti />
        )}
      </SearchAddressContent>
      {hasResult && totalNum > 0 && (
        <PaginationWrap>
          <BoardPagination
            page={page}
            handlePage={handlePage}
            value={_value}
            totalPages={Math.ceil(totalNum / SIZE)}
            showPages={10}
            paginationType={'static'}
            hasFirstArrow={false}
            hasLastArrow={false}
          />
        </PaginationWrap>
      )}
    </SearchAddressWrap>
  );
}

const PaginationWrap = styled.div`
  margin-top: auto;
`;

const SearchAddressWrap = styled.div`
  padding: 0px 40px 40px;
  min-height: 586px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const SearchAddressContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const SearchInputWrap = styled.div`
  width: 490px;
  height: 48px;
  position: relative;
`;

const InputError = styled.div`
  margin-top: 8px;
  margin-left: 20px;
  ${theme.typography.caption1};
  color: ${theme.colors.accent_colors.error};
`;

const SearchInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: none;
  padding: 0px 76px 0px 20px;
  margin: 0px;
  background-color: ${theme.colors.neutral_colors.gray[50]};
  border-radius: 24px;
  color: ${theme.colors.neutral_colors.primary};
  ${theme.typography.body2};
  caret-color: ${theme.colors.accent_colors.red.default};
  &::placeholder {
    color: ${theme.colors.neutral_colors.gray[500]};
    ${theme.typography.body2};
  }
`;

const SearchButtonWrap = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchDeleteButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0px;
  margin: 0px;
  background-color: transparent;
  cursor: pointer;
`;

const SearchButton = styled.button`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0px;
  margin: 0px;
  background-color: transparent;
  cursor: pointer;
`;

export default SearchAddress;
